/**
 * @flow
 * @relayHash fc65eadbad6ec2d40bd4dd13afd2e0dd
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
type StreamList_viewer$ref = any;
export type queries_StreamList_QueryVariables = {|
  page: number,
  states?: ?$ReadOnlyArray<?string>,
|};
export type queries_StreamList_QueryResponse = {|
  +viewer: ?{|
    +$fragmentRefs: StreamList_viewer$ref
  |}
|};
export type queries_StreamList_Query = {|
  variables: queries_StreamList_QueryVariables,
  response: queries_StreamList_QueryResponse,
|};
*/


/*
query queries_StreamList_Query(
  $page: Int!
  $states: [String]
) {
  viewer {
    ...StreamList_viewer_in1hr
    id
  }
}

fragment StreamList_viewer_in1hr on Viewer {
  streams: streamsPaginate(pageSize: 10, page: $page, states: $states) {
    totalCount
    streams {
      ...StreamListItem_stream
      id
    }
  }
}

fragment StreamListItem_stream on Stream {
  id
  title
  state
  availableAt
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "page",
    "type": "Int!",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "states",
    "type": "[String]",
    "defaultValue": null
  }
],
v1 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
};
return {
  "kind": "Request",
  "operationKind": "query",
  "name": "queries_StreamList_Query",
  "id": null,
  "text": "query queries_StreamList_Query(\n  $page: Int!\n  $states: [String]\n) {\n  viewer {\n    ...StreamList_viewer_in1hr\n    id\n  }\n}\n\nfragment StreamList_viewer_in1hr on Viewer {\n  streams: streamsPaginate(pageSize: 10, page: $page, states: $states) {\n    totalCount\n    streams {\n      ...StreamListItem_stream\n      id\n    }\n  }\n}\n\nfragment StreamListItem_stream on Stream {\n  id\n  title\n  state\n  availableAt\n}\n",
  "metadata": {},
  "fragment": {
    "kind": "Fragment",
    "name": "queries_StreamList_Query",
    "type": "Query",
    "metadata": null,
    "argumentDefinitions": v0,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "Viewer",
        "plural": false,
        "selections": [
          {
            "kind": "FragmentSpread",
            "name": "StreamList_viewer",
            "args": [
              {
                "kind": "Variable",
                "name": "page",
                "variableName": "page",
                "type": null
              },
              {
                "kind": "Variable",
                "name": "states",
                "variableName": "states",
                "type": null
              }
            ]
          }
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "queries_StreamList_Query",
    "argumentDefinitions": v0,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "Viewer",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": "streams",
            "name": "streamsPaginate",
            "storageKey": null,
            "args": [
              {
                "kind": "Variable",
                "name": "page",
                "variableName": "page",
                "type": "Int"
              },
              {
                "kind": "Literal",
                "name": "pageSize",
                "value": 10,
                "type": "Int"
              },
              {
                "kind": "Variable",
                "name": "states",
                "variableName": "states",
                "type": "[String]"
              }
            ],
            "concreteType": "StreamsPagination",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "totalCount",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "streams",
                "storageKey": null,
                "args": null,
                "concreteType": "Stream",
                "plural": true,
                "selections": [
                  v1,
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "title",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "state",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "availableAt",
                    "args": null,
                    "storageKey": null
                  }
                ]
              }
            ]
          },
          v1
        ]
      }
    ]
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'dd9ce086d9418371d5f233346d6c25e4';
module.exports = node;



// WEBPACK FOOTER //
// src/__generated__/queries_StreamList_Query.graphql.js